import template from './mobile-search-block.pug';
import './mobile-search-block.scss';

export const MobileSearchBlockComponent = {
  template,
  bindings: {
    columnDefs: '<',
    applyFilter: '&',
    filter: '<'
  },
  transclude: true,
  controller: class MobileSearchBlockComponent {
    constructor() {
      'ngInject';
      this.model = '';
      this.isVisibleAdvancedSearch = false;
      this.timeoutId = null;
    }

    $onInit() {
      console.log('this.columnDefs', this.columnDefs);
      // this.columnDefs = this.columnDefs.filter((column) => column.mobile_search);
    }

    toggleAdvancedSearch() {
      this.isVisibleAdvancedSearch = !this.isVisibleAdvancedSearch;
      this.clearFilter();
    }

    clearFilter() {
      for (const key in this.filter) {
        if (key !== 'page' && key !== 'sort_by' && key !== 'sort_to' && key !== 'record_status_id') {
          delete this.filter[key];
        }
      }

      this.applyFilter({ $event: { filter: this.filter } });
    }

    onEdit = ({ filter }) => {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => this.applyFilter({ $event: { filter } }), 700);
    };
  },
};
